import type { MediaRenderer } from 'voximplant-websdk/Media/MediaRenderer';

import { getMainContentContainerId } from 'store/conference/helpers/getSharingVideoContainerId';

import { playVideo } from 'utils/playVideo';

class ScreenShareManager {
    private _map = new Map<
        string,
        {
            /** Очистить контент демонстрации экрана */
            clear: () => void;
            /** Вывод демонстрации экрана */
            draw: () => void;
        }
    >();

    /** Добавить пользователя в список управления демонстрацией экрана */
    public set({ mediaRenderer, userId }: { mediaRenderer: MediaRenderer; userId: string }) {
        const getScreenShareInstanceForCurrentUser = () => this.getScreenShareManagerByUserId(userId);

        this._map.set(userId, {
            clear: () => {
                const sharingNode = ScreenShareManager.getSharingNode();

                if (sharingNode) sharingNode.textContent = '';

                return getScreenShareInstanceForCurrentUser();
            },
            draw: () => {
                const sharingNode = ScreenShareManager.getSharingNode();

                if (sharingNode && mediaRenderer) {
                    mediaRenderer.render(sharingNode);

                    playVideo(sharingNode);
                }

                return getScreenShareInstanceForCurrentUser();
            },
        });

        return getScreenShareInstanceForCurrentUser();
    }

    /** Получить контейнер для отрисовки демонстрации экрана */
    private static getSharingNode() {
        return document.getElementById(getMainContentContainerId());
    }

    /** Удалить пользователя из списка управления демонстрацией экрана */
    public remove(userId: string) {
        this._map.delete(userId);

        return this._map;
    }

    /** Получить пользователя из списка управления демонстрацией экрана */
    public getScreenShareManagerByUserId(userId: string) {
        return this._map.get(userId);
    }
}

export const screenShareManager = new ScreenShareManager();
